import React from 'react';

export function InitialIcon({
    initials, widthValue, font, paddingValue, heightValue, color,
}) {
    return (
        <div
            style={{

                borderRadius: '50%',
                background: '#555259',
                color: color || '#fff',
                textAlign: 'center',
                marginLeft: '21px',
                width: Number(widthValue),
                height: Number(heightValue),
                display: 'flex',
                justifyContent: 'center',
                padding: color ? '20px' : '',
                alignItems: 'center',
            }}
        >
            <h5 style={{
                color: paddingValue ? '#E2E2E2' : '#FFFFFF',
                fontSize: font,
                padding: paddingValue,
                font: paddingValue ? 'normal normal bold 18px/23px Source Sans Pro' : '#E2E2E2',
            }}
            >
                {initials}

            </h5>
        </div>

    );
}
